<template>
    <CDataTable
        hover
        striped
        clickable-rows
        :column-filter="showFilters"
        :items="filteredData"
        :fields="fields"
        :items-per-page="10"
        :active-page="currentPage"
        :pagination="{ doubleArrows: true, align: 'center'}"
        @row-clicked="rowClicked"
        @page-change="pageChange"
    >
        <template #type-filter>
            <CSelect
                :options="categoryTypeList"
                :value.sync="selectedCategoryType"
                :horizontal="{input: 'col-sm-12'}"
                size="sm"
                style="margin-bottom: 0;"
            />
        </template>
        <template #type="{item}">
            <td>{{ getCategoryTypeLabel(item.type) }}</td>
        </template>
    </CDataTable>
</template>

<script>
    import Vue from 'vue';

    export default {
        props: {
            data: {
                type: Array,
                default: () => []
            },

            showFilters: {
                type: Boolean,
                default: true
            }
        },

        data: () => ({
            selectedCategoryType: undefined,
            fields: [
                { key: 'id', label: 'ID', _classes: 'font-weight-bold' },
                { key: 'title', label: 'Название' },
                { key: 'type', label: 'Тип' },
            ],
            categoryTypeList: [
                { value: '', label: 'Выберите...' },
                { value: 'restaurant', label: 'Рестораны' }
            ]
        }),

        computed: {
            currentPage() {
                return parseInt(this.$route.query.page) || 1
            },

            filteredData() {
                if (!this.selectedCategoryType) {
                    return this.data
                }

                return this.data.filter(item => item.type === this.selectedCategoryType)
            }
        },

        async mounted() {
            await this.getTypes();
        },

        methods: {
            rowClicked(item) {
                const path = `categories/${item.id}`
                this.$router.push({ path })
            },

            pageChange(val) {
                const query = { page: val }
                this.$router.push({ query })
            },

            getCategoryTypeLabel(value) {
                const categoryType = this.categoryTypeList.find(type => type.value === value)

                if (!categoryType || !categoryType.value) {
                    return ''
                }

                return categoryType.label
            },

            async getTypes() {
                Vue.axios.get('/entities-type')
                    .then(resp => {
                        resp.data.forEach(({ code, title }) => {
                            const condidate = this.categoryTypeList.find(type => type.value === code);
                            if (!condidate) {
                                this.categoryTypeList.push({
                                    value: code,
                                    label: title
                                });
                            }
                        });
                    })
                    .catch((err) => {
                        this.$root.$emit('showError', 'Ошибка загрузки данных. ' + err);
                    });
            },
        }
    }
</script>

<style>

</style>
